/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // (Removed a dead "Mobile Megamenu Handler" that drove an off-canvas
  // .nav--default drawer via a js-drawer-open-header class nothing ever set —
  // the working mobile menu is the theme's native .drawer--nav. See
  // specs/sections/mobile-drawer-account-link.md for the finding.)

  // No Variant Selected by Default - Hide Add to Cart and Buy It Now buttons
  function initVariantSelection() {
    const productForms = document.querySelectorAll('[data-product-form]');
    
    productForms.forEach(function(form) {
      const product = form.closest('[data-product]');
      if (!product) return;
      
      const addToCartButton = product.querySelector('[data-add-to-cart]');
      const buyItNowContainer = product.querySelector('.shopify-payment-button');
      const variantSelectors = product.querySelectorAll('[data-single-option-selector]');
      const idInput = form.querySelector('[name="id"]');
      
      // Function to check if a valid variant is selected
      function hasValidVariantSelected() {
        // Check if there's a variant ID in the hidden input
        const variantId = idInput ? idInput.value : '';
        if (!variantId || variantId === '') {
          return false;
        }
        
        // Check if all option selectors have values (not placeholder)
        let allOptionsSelected = true;
        variantSelectors.forEach(function(selector) {
          const value = selector.value || '';
          if (value === '' || selector.closest('[data-placeholder-option]')) {
            allOptionsSelected = false;
          }
        });
        
        return allOptionsSelected;
      }
      
      // Function to update button visibility
      function updateButtonVisibility() {
        const isValidVariant = hasValidVariantSelected();
        
        if (addToCartButton) {
          if (isValidVariant) {
            product.classList.remove('variant-not-selected');
            addToCartButton.classList.remove('hidden');
          } else {
            product.classList.add('variant-not-selected');
            addToCartButton.classList.add('hidden');
          }
        }
        
        if (buyItNowContainer) {
          if (isValidVariant) {
            buyItNowContainer.classList.remove('hidden');
          } else {
            buyItNowContainer.classList.add('hidden');
          }
        }
      }
      
      // Initialize - check initial state
      updateButtonVisibility();
      
      // Listen for changes on variant selectors (radio, checkbox, select)
      variantSelectors.forEach(function(selector) {
        selector.addEventListener('change', function() {
          // Small delay to let the form update
          setTimeout(updateButtonVisibility, 50);
        });
      });
      
      // Listen for changes on dropdown selectors (popout-select)
      const popoutSelects = product.querySelectorAll('[data-popout-option]');
      popoutSelects.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          const value = option.getAttribute('data-value');
          
          // Check if it's a placeholder option
          if (value === '' || option.hasAttribute('data-placeholder-option')) {
            setTimeout(function() {
              product.classList.add('variant-not-selected');
              if (addToCartButton) addToCartButton.classList.add('hidden');
              if (buyItNowContainer) buyItNowContainer.classList.add('hidden');
            }, 100);
          } else {
            // Wait for the form to update the variant
            setTimeout(updateButtonVisibility, 100);
          }
        });
      });
      
      // Observer for dynamic changes to the ID input (in case theme.js updates it)
      if (idInput) {
        const observer = new MutationObserver(function() {
          updateButtonVisibility();
        });
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  }
  
  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initVariantSelection);
  
  // Also initialize on Shopify section load (for quick view, etc.)
  document.addEventListener('shopify:section:load', initVariantSelection);


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
